import React from "react"

import { Box, Button, Typography, makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
  heading: {
    marginBottom: "30px",
  },
})

const ArticleSection = props => {
  const {
    mb,
    img,
    alt,
    heading,
    headingVariant,
    textAlign,
    primaryLabel,
    primaryHref,
    children,
  } = props
  const classes = useStyles()

  const renderButton = () => {
    return (
      primaryLabel && (
        <Box mt="50px" textAlign="center">
          <Button color="primary" variant="contained" href={primaryHref}>
            {primaryLabel}
          </Button>
        </Box>
      )
    )
  }

  return (
    <Box textAlign="center" px={2.5} mb={mb}>
      {img && (
        <Box mb={3.75}>
          <img src={img} alt={alt} />
        </Box>
      )}
      <Typography
        className={classes.heading}
        variant={headingVariant}
        align="center"
      >
        {heading}
      </Typography>
      <Box maxWidth="600px" mx="auto" textAlign={textAlign}>
        {children}
        {renderButton()}
      </Box>
    </Box>
  )
}

export default ArticleSection
